/**
 * @category Types and Interfaces
 */
export enum SupportedTypesEnum {
  Array,
  Boolean,
  Number,
  String
}
